'use client'

import { cn, getVersionForClone } from '@qr-front/ui/utils'
import { ROUTES } from 'constants/routesConstants'

import { BaseLogoSvg } from '@/components/LogoLink/BaseLogoSvg'
import { Clone1LogoSvg } from '@/components/LogoLink/Clone1LogoSvg'
import { Link, usePathname } from '@/i18n-routing'

type TLogoProps = {
	href?: string
	isDisabled?: boolean
	textClassName?: string
	size?: number
}

const LogoSvg = getVersionForClone<typeof BaseLogoSvg | typeof Clone1LogoSvg>({
	base: BaseLogoSvg,
	clone1: Clone1LogoSvg,
})

export const LogoLink = ({
	href = ROUTES.index,
	isDisabled = false,
	textClassName,
	size,
}: TLogoProps) => {
	const pathname = usePathname()

	if (isDisabled) {
		return (
			<span
				aria-disabled="true"
				tabIndex={-1}
				className={cn('pointer-events-none shrink-0 cursor-default')}
			>
				<LogoSvg textClassName={textClassName} size={size} />
			</span>
		)
	}

	return (
		<Link
			href={href}
			className={cn('shrink-0 cursor-pointer')}
			// Next 15+ skips same-URL navigations, which used to scroll to top
			onClick={() => {
				if (pathname === href) window.scrollTo(0, 0)
			}}
		>
			<LogoSvg textClassName={textClassName} size={size} />
		</Link>
	)
}
